import React from 'react';
import { Trans } from 'react-i18next';
import { Box as Wrapper, Icon, Text, useColorMode } from '@tonic-ui/react';

const TextBlock = (props) => {
  const [colorMode] = useColorMode();
  const fontColour = colorMode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'gray:40';

  return <Text color={fontColour} {...props} />;
};

export const accountsTableColumns = (toggleNestedRows = false) => {
  const tableColumns = [
    {
      Header: <Trans i18nKey="accountSelection.alias" />,
      accessor: 'alias',
      id: 'alias',
      width: 'auto',
    },
    {
      Header: <Trans i18nKey="accountSelection.id" />,
      accessor: 'id',
      id: 'id',
      width: 'auto',
    },
    {
      Header: <Trans i18nKey="accountSelection.myRole" />,
      accessor: 'roleID',
      id: 'roleID',
      width: 'auto',
      Cell: ({ row }) => {
        return row?.canExpand && !row?.isExpanded ? (
          <TextBlock as="i">
            <Trans i18nKey="accountSelection.multipleRoles" />
          </TextBlock>
        ) : row?.isExpanded ? (
          ''
        ) : (
          row?.original?.roleID
        );
      },
    },
    {
      Header: <Trans i18nKey="accountSelection.region" />,
      accessor: 'region',
      id: 'region',
      width: 'auto',
    },
    {
      Header: <Trans i18nKey="accountSelection.mfaRequired" />,
      accessor: 'mfaRequired',
      id: 'mfaRequired',
      width: 'auto',
      sortType: 'basic',
      Cell: ({ row }) => {
        return (
          <Wrapper paddingLeft={20}>
            {row.original.mfaRequired && <Icon icon="check-bold" color="green:50" />}
          </Wrapper>
        );
      },
    },
  ];

  if (toggleNestedRows) {
    if (tableColumns[0].id === 'showExpandableRows') return;
    tableColumns.unshift({
      id: 'showExpandableRows',
      width: 50,
      Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded, row }) =>
        row?.canExpand ? (
          <Wrapper {...getToggleAllRowsExpandedProps()}>
            {isAllRowsExpanded ? <Icon icon="angle-down" /> : <Icon icon="angle-right" />}
          </Wrapper>
        ) : null,
      Cell: ({ row }) =>
        row?.canExpand ? (
          <Wrapper {...row.getToggleRowExpandedProps()}>
            {row?.isExpanded ? <Icon icon="angle-down" /> : <Icon icon="angle-right" />}
          </Wrapper>
        ) : null,
    });
  }

  return tableColumns;
};
